import { ReactElement } from 'react';

export interface TagListProps<T> {
  list?: Array<T>;
  itemClassName?: string;
  onRemoveItem: (item: T) => void;
  leftColumn?: (item: T) => ReactElement | string | number;
  rightColumn?: (item: T) => ReactElement | string | number;
}

const TagList = <T,>(props: TagListProps<T>): ReactElement => {
  return (
    <>
      {props.list && (
        <ul className="tw-flex tw-flex-col tw-gap-2">
          {props.list.map((item, index: number) => (
            <li
              key={index}
              className={`tw-flex tw-items-center tw-justify-between tw-break-all tw-border tw-border-raa-gray-3 tw-bg-raa-gray-1 tw-px-2 tw-py-2 ${props.itemClassName}`}
              data-testid="tag-item"
            >
              {props.leftColumn && <div>{props?.leftColumn(item)}</div>}
              <div className="tw-flex">
                {props.rightColumn && props.rightColumn(item)}
                <button
                  type="button"
                  aria-label="close"
                  onClick={() => props.onRemoveItem(item)}
                  className="raa-icon raa-icon-close tw-ml-6 tw-w-[24px] tw-rounded tw-text-raa-orange focus:tw-bg-raa-orange focus:tw-text-raa-white focus:tw-outline-transparent"
                />
              </div>
            </li>
          ))}
        </ul>
      )}
    </>
  );
};

export default TagList;
